 const otherLotCodesReducer = (state = [{code: "", description: ""}, {code: "ALL", description: "All"}], action) => {
  switch (action.type) {
    case 'LANDLINK_OTHER_LOT_CODES':
      return action.results;
    default:
      break;
  }
  return state;
}

export default otherLotCodesReducer;